import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { sendClickSoundCommand, sendHoverSoundCommand } from 'react-wot-bootstrap/lib/helpers/web_to_client'

import styles from './InfoButton.scss'

class InfoButton extends PureComponent {
    render() {
        return (
            <button
                className={styles.base}
                onClick={this.props.onClick}
                onMouseDown={sendClickSoundCommand}
                onMouseEnter={sendHoverSoundCommand}
            >
                <span className={styles.icon} />
                <span className={styles.caption}>
                    {this.props.caption}
                </span>
            </button>
        )
    }
}

InfoButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    caption: PropTypes.element.isRequired,
}

export default InfoButton


// WEBPACK FOOTER //
// ./components/InfoButton/InfoButton.jsx